import GlobalConstants from '../../../../components/GlobalConstants';
import $ from 'cash-dom';

const TYPE_DROPDOWN = 'dropdown';
const TYPE_INPUT = 'input';
const TYPE_RANGE_INPUT = 'range-input';
const TYPE_CHECKBOX = 'checkbox';
const TYPE_SELECTBOX = 'selectbox';
const TYPE_RADIO_GROUP = 'radio-group';
const TYPE_TAB = 'tab';
const EVENT_FILTER_FIELD_CHANGE = 'filter-field-change';

/**
 * Class BaseField - is base field filter class. If you need to add new filter field, please, extend this class
 * and implement needed methods (which throws Error(GlobalConstants.OVERRIDE_ERROR_MESSAGE)).
 * Then you can add it creation in `FieldsBuilder.build()`.
 * @abstract
 */
class BaseField {
	static get TYPE_DROPDOWN () {
		return TYPE_DROPDOWN;
	}

	static get TYPE_INPUT () {
		return TYPE_INPUT;
	}

	static get TYPE_RANGE_INPUT () {
		return TYPE_RANGE_INPUT;
	}

	static get TYPE_CHECKBOX () {
		return TYPE_CHECKBOX;
	}

	static get TYPE_SELECTBOX () {
		return TYPE_SELECTBOX;
	}

	static get TYPE_RADIO_GROUP () {
		return TYPE_RADIO_GROUP;
	}


	static get TYPE_TAB () {
		return TYPE_TAB;
	}


	/**
	 * Event name that is triggered when filter field value changes.
	 * @return {string} The filter field change event name.
	 */
	static get EVENT_FILTER_FIELD_CHANGE () {
		return EVENT_FILTER_FIELD_CHANGE;
	}

	constructor($input) {
		this._$input = $input;
		this._name = $input.attr('name');
		this._isLinkTheSameAsCurrentUrl = false;

		const $fieldset = this._$input.closest('fieldset');
		const $filterContainer = $fieldset.closest('.filter-container');
		this._isHidden = ($fieldset.length && $fieldset.hasClass('hidden'))
			|| ($filterContainer.length && $filterContainer.hasClass('hidden'));

		this._withDeeplinks = null;
	}

	get name() {
		return this._name;
	}

	get isLinkTheSameAsCurrentUrl() {
		return this._isLinkTheSameAsCurrentUrl;
	}

	/**
	 * Gets input label.
	 * @private
	 */
	_getLabel() {
		throw new Error(GlobalConstants.OVERRIDE_ERROR_MESSAGE);
	}

	/**
	 * Sets value and triggers field specific event.
	 * @param {string|any} filterValue
	 */
	setValueAndTriggerEvent(filterValue) {
		throw new Error(GlobalConstants.OVERRIDE_ERROR_MESSAGE);
	}

	setValue(filterValue) {
		this._$input.val(filterValue);
	}

	_getName() {
		return this._$input.attr('name');
	}

	getVendors() {
		return this._$input.data('vendors');
	}

	/**
	 * Gets vendors with order
	 * @return {string[]|null}
	 */
	getVendorsWithOrder() {
		return [];
	}

	/**
	 * @return {{fieldName, fieldValue}}
	 */
	getNameAndValue() {
		return {
			fieldName: this._getName(),
			fieldValue: this.getValue(),
		};
	}

	getValue() {
		return this._$input.val();
	}

	/**
	 * @return {fieldName, fieldLabel}
	 */
	getNameAndLabel() {
		return {
			fieldName: this._getName(),
			fieldLabel: this._getLabel(),
		};
	}

	getNameAndDeeplinks() {
		return {
			fieldName: this._getName(),
			fieldDeeplinks: this._getDeeplinks(),
		}
	}

	_getDeeplinks() {
		return this._$input.data('deeplinks');
	}

	isHidden() {
		return this._isHidden;
	}

	getRedirectLinkForValue(filterValue) {
		return null;
	}

	/**
	 * Returns true if the field has at least one option with deeplinks. Otherwise false is returened.
	 * @return {boolean}
	 */
	isWithDeeplinks() {
		if (this._withDeeplinks === null) {
			let isWithDeeplinks = false;

			const possibileEmptyDeeplinks = ['', null, undefined, '{"":""}', "{'':''}", '[]'];
			const fieldOptionsWithDeeplinks = this._$input.find('[data-deeplinks]');

			for (const fieldOptionWithDeeplinks of fieldOptionsWithDeeplinks) {
				const $fieldOptionWithDeeplinks = $(fieldOptionWithDeeplinks);

				if (!possibileEmptyDeeplinks.includes($fieldOptionWithDeeplinks.attr('data-deeplinks'))) {
					isWithDeeplinks = true;
					break;
				}
			}

			this._withDeeplinks = isWithDeeplinks;
		}

		return this._withDeeplinks;
	}

	getShowVisiblyHiddenVendor() {
		return false;
	}

	isWithVisiblyHiddenSplit() {
		return false;
	}
}

export default BaseField;
